<template>
  <div class="form-ctrl" :class="{ small: small, large: large }">
    <small v-if="label">{{ label }}: {{ required ? "*" : "" }} </small>
    <select
      :id="id"

      @change="$emit('input', $event.target.value)"
    >
      <option
        v-for="(item, index) in items"
        :value="itemValue ? item[itemValue] : item"
        :key="index"
        >{{ itemText ? item[itemText] : item }}</option
      >
    </select>
    <div class="invalid" v-if="error">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },
    value: {
      type: Number
    },
    label: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    itemText: {
      type: String
    },
    itemValue: {
      type: String
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.small {
  width: 60% !important;
  @media screen and (max-width: 800px) {
    width:100% !important;
  }
}
.form-ctrl {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 10px;
  small {
    color: grey;

  }
  input[type="text"],
  select {
    background-image: none;
    background-color: transparent;
    box-shadow: none;
    border-radius: 6px;
    border: 1px solid #231F20;
    padding: 7px;
    width: 100%;
    @media screen and (max-width: 800px) {
      margin-bottom: 10px;
    }
  }
}
.form-ctrl:first-child {
  margin-left: 0 !important;
}
.invalid {
  color: red;
  font-size: 12px;
  margin-top: 3px;
}
</style>
